export function capitalizeText(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getAnchorId(text: string) {
  return text.toLowerCase().replaceAll(/[ |_]/g, '-').replace(/:$/, '');
}

export const getInitials = (name = ''): string =>
  name
    .replace(/\s+/, ' ')
    .split(' ')
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join('');
